import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { dynamicPageView } from '../utils/tracking';

export const usePageTracking = () => {
  const location = useLocation();
  const lastTrackedPath = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    // Only track if the path has actually changed
    if (lastTrackedPath.current !== currentPath) {
      lastTrackedPath.current = currentPath;
      dynamicPageView();
    }
  }, [location.pathname, location.search]);
};

